import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '/'
  }, {
    name: 'Events',
    href: '/events'
  }, {
    name: 'Manifiesto',
    href: '/#manifiesto'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-cream/95 backdrop-blur-md py-4 border-b border-navy/5' : 'bg-transparent py-6'}`} data-id="element-126">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-127">
        <div className="flex flex-col" data-id="element-128">
          <span className="text-[10px] font-sans font-bold uppercase tracking-[0.2em] text-navy/60 mb-0.5" data-id="element-129">
            REURBANO
          </span>
          <a href="#" className="flex items-center gap-2 font-serif font-bold text-2xl tracking-tight text-navy hover:opacity-80 transition-opacity" data-id="element-130">
            <img src="https://substackcdn.com/image/fetch/w_80,h_80,c_fill,f_webp,q_auto:good,fl_progressive:steep/https%3A%2F%2Fsubstack-post-media.s3.amazonaws.com%2Fpublic%2Fimages%2F160e90df-0a0d-4a89-80fd-69aaa3c16c48_256x256.png" alt="Familiar Spaces door icon" className="h-7 w-auto object-contain" data-id="element-131" />
            familiar spaces
          </a>
        </div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-132">
          {navLinks.map(link => <Link key={link.name} to={link.href} className="text-sm font-medium text-navy/80 hover:text-navy transition-colors" data-id="element-133">
              {link.name}
            </Link>)}
          <Link to="/#join" className="px-5 py-2.5 bg-marigold text-navy rounded-full text-sm font-medium hover:bg-marigold/90 transition-colors" data-id="element-134">
            Join the community
          </Link>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-navy p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-135">
          {mobileMenuOpen ? <X size={24} data-id="element-136" /> : <Menu size={24} data-id="element-137" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-cream border-t border-navy/10 py-4 px-6 flex flex-col gap-4 shadow-xl" data-id="element-138">
          {navLinks.map(link => <Link key={link.name} to={link.href} className="text-base font-medium text-navy/80 py-2" onClick={() => setMobileMenuOpen(false)} data-id="element-139">
              {link.name}
            </Link>)}
          <Link to="/#join" className="px-5 py-3 bg-marigold text-navy rounded-full text-center font-medium mt-2" onClick={() => setMobileMenuOpen(false)} data-id="element-140">
            Join the community
          </Link>
        </div>}
    </header>;
}